import { render, staticRenderFns } from "./QuestionRender.vue?vue&type=template&id=5b04da06&scoped=true"
import script from "./QuestionRender.vue?vue&type=script&lang=js"
export * from "./QuestionRender.vue?vue&type=script&lang=js"
import style0 from "./QuestionRender.vue?vue&type=style&index=0&id=5b04da06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b04da06",
  null
  
)

export default component.exports